const clients = [
  { name: "DIAL", logo: "/images/clients/DIAL.png" },
  { name: "GMR", logo: "/images/clients/GMR.png" },
  { name: "AAI", logo: "/images/clients/AAI.png" },
  { name: "Unilode", logo: "/images/clients/unilode.png" },
  { name: "Knight Frank", logo: "/images/clients/knight-frank.png" },
  { name: "Encalm Hospitality", logo: "/images/clients/encalm.png" },
  { name: "TFS", logo: "/images/clients/tfs.png" },
  { name: "Ospree Duty Free", logo: "/images/clients/ospree-duty-free.png" },
  { name: "Indian Railways", logo: "/images/clients/indian-railways.png" },
];

export const TrustedBy = () => {
  return (
    <section className="bg-zinc-900 py-20 overflow-hidden border-y border-zinc-800">
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            animation: scroll 30s linear infinite;
            width: max-content;
          }
          .marquee-container:hover .animate-marquee {
            animation-play-state: paused;
          }
          .mask-gradient {
            mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
            -webkit-mask-image: linear-gradient(to right, transparent, black 20%, black 80%, transparent);
          }
        `}
      </style>
      <div className="max-w-7xl mx-auto px-6 mb-16 text-center">
        <h3 className="text-sm font-serif italic tracking-widest text-zinc-500">
          Trusted By Global Aviation Giants
        </h3>
      </div>

      <div className="marquee-container w-full overflow-hidden flex mask-gradient py-4">
        <div className="animate-marquee flex gap-20 md:gap-40 items-center pl-20 md:pl-40">
          {/* First set of logos */}
          {clients.map((client, index) => (
            <div
              key={`1-${index}`}
              className="group relative flex items-center justify-center min-w-[12rem] h-24 select-none cursor-default grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500 hover:scale-110">
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                className="max-h-16 w-auto object-contain brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-300"
              />
            </div>
          ))}

          {/* Duplicate set for infinite scroll */}
          {clients.map((client, index) => (
            <div
              key={`2-${index}`}
              className="group relative flex items-center justify-center min-w-[12rem] h-24 select-none cursor-default grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500 hover:scale-110">
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                className="max-h-16 w-auto object-contain brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
